module.exports = __webpack_public_path__ + "static/media/po-EGR-Cooler.bcc2ea8e.png";